<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

const appVersion = ref(__APP_VERSION__)
const appVersionDate = ref(__APP_VERSION_DATE__)
const { d } = useI18n()

if (!appVersion.value) {
  appVersion.value = 'unknown'
  console.warn('App version is not defined. Please check your build configuration.')
}
</script>

<template>
  <div class="flex items-center space-x-2">
    <span class="text-sm text-gray-600 dark:text-gray-400">
      Version:
      <span class="text-sm font-semibold"
        >{{ appVersion }} ({{ d(appVersionDate, 'dateonly') }})</span
      >
    </span>
  </div>
</template>
